import { render, staticRenderFns } from "./ShipmentAddPodPopup.vue?vue&type=template&id=9afdf30c&"
import script from "./ShipmentAddPodPopup.vue?vue&type=script&lang=js&"
export * from "./ShipmentAddPodPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports